function SettingsTextField({
  id,
  value,
  onChange,
  disabled = false,
  multiline = false,
}) {
  if (multiline) {
    return (
      <textarea
        id={id}
        className="settings-textarea"
        value={value ?? ""}
        disabled={disabled}
        rows={6}
        onChange={(e) => onChange(e.target.value)}
      />
    );
  }

  return (
    <input
      id={id}
      className="settings-input"
      type="text"
      value={value ?? ""}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default SettingsTextField;